import ButtonsDataTable from "../../../components/dataTable/tables/ButtonsDataTable";

function ButtonsPageView() {
  return <ButtonsDataTable />;
}

export default ButtonsPageView;